var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
    cookie = require('js-cookie');
    throttle = require('lodash.throttle'),
    wp = (typeof window !== "undefined" ? window['wpVars'] : typeof global !== "undefined" ? global['wpVars'] : null);

function SubscribeBar(el) {
  var $el = $(el),
      $bar = $el,
      $window = $(window),
      $closeButton = $el.find('.subscribe__close-icon'),
      $submitButton = $el.find('.gform_button'),
      $staticBar = $('.subscribe--footer'),
      $form = $el.find('.subscribe__forms'),
      $inner = $el.children('.subscribe__inner'),
      $message = $el.find( '.subscribe__message' ),
      $email = $el.find( '.subscribe__email' );

  $message.appendTo($email);

  $form.on('submit', function(e) {
    var $target = $(this);
    e.preventDefault();
    $el.addClass('js-submitting');

    $.ajax({
      type: "POST",
      dataType: "json",
      url: wp.ajaxUrl,
      data: {
        action: 'subscribe',
        data: $target.serialize(),
        location: location.href
      },
      success: function(response) {
        var messages = [];
        if ( response.is_valid ) {
          $message.text($(response.confirmation_message).text());
          $message.appendTo($inner);
          $el.addClass('js-submitted');
          $form.remove();
        } else {
          for ( var i in response.validation_messages ) {
            messages.push(response.validation_messages[i]);
          }
          $message.html( messages.join( '<br>' ) );
        }
        $el.removeClass('js-submitting');
        $el.addClass('js-has-message');
      },
      error: function() {
        alert( 'Cannot submit form. Please try again or contact site administrator.' );
      }
    })

    return false;
  });

  if ( ! $el.data( 'subscribe-modal' ) ) {
    return;
  }
  $message.prependTo($el.find('.subscribe__forms_wrapper'));
  if( cookie.get('subscribe--bar') !== 'true' ) {
    if( cookie.get('subscribe--bar-submitted') == 'true' ) {
      $bar.removeClass('hide');
    } else {
      $window.on('scroll', throttle(function() {
        var scroll = $(this).scrollTop();

        if(scroll > 1 && scroll + $window.height() < $staticBar.offset().top) {
          $bar.removeClass('hide');
        } else {
          $bar.addClass('hide');
        }
      }, 50));
    }
  }

  $submitButton.on('click', function(e) {
    cookie.set('subscribe--bar-submitted', 'true');
  });

  $closeButton.on('click', function(e) {
    e.preventDefault();
    cookie.set('subscribe--bar', 'true');
    $bar.remove();
  });

}

module.exports = SubscribeBar;
